import { getJson } from '@zapier/common-utils';
import { TrackingMiddleware } from '../types';

const createMaybeAddUserId: TrackingMiddleware = () => {
  const resolvedCurrentProfileId = getJson('/api/v3/profiles');
  return async event => {
    try {
      const { active_id } = await resolvedCurrentProfileId;
      event.apply({
        userId: active_id,
      });

      event._deprecatedSetProprtiesInRoot(['userId']);
    } catch (e) {
      // ignore errors
    }
  };
};

export default createMaybeAddUserId;
